import React, { useState } from 'react';
import './CreateMasterProjectModal.css'; // Reuse the same modal styling

function MoveProjectModal({ isOpen, project, masterProjects, onMove, onCancel }) {
  const [selectedMasterProjectId, setSelectedMasterProjectId] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  if (!isOpen || !project) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedMasterProjectId) {
      alert('Please select a master project');
      return;
    }

    if (parseInt(selectedMasterProjectId) === project.master_project_id) {
      alert('Project is already in this master project');
      return;
    }

    setIsSubmitting(true);
    try {
      await onMove(project.id, parseInt(selectedMasterProjectId));
    } catch (error) {
      console.error('Error moving project:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleCancel = () => {
    setSelectedMasterProjectId('');
    onCancel();
  };

  // Filter out the current master project from the list
  const availableMasterProjects = masterProjects.filter(mp => mp.id !== project.master_project_id);

  return (
    <div className="modal-overlay" onClick={handleCancel}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>Move Project</h2>
          <button
            onClick={handleCancel}
            className="modal-close-button"
            disabled={isSubmitting}
          >
            ×
          </button>
        </div>
        
        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label>Project:</label>
            <div style={{ 
              padding: '10px 12px', 
              backgroundColor: '#f8f9fa', 
              border: '1px solid #ddd', 
              borderRadius: '6px',
              fontWeight: '500'
            }}>
              {project.title}
            </div>
          </div>

          <div className="form-group">
            <label htmlFor="masterProject">Move to Master Project:</label>
            <select
              id="masterProject"
              value={selectedMasterProjectId}
              onChange={(e) => setSelectedMasterProjectId(e.target.value)}
              required
              disabled={isSubmitting}
              style={{
                width: '100%',
                padding: '10px 12px',
                border: '1px solid #ddd',
                borderRadius: '6px',
                fontSize: '1rem',
                backgroundColor: 'white'
              }}
            >
              <option value="">Select a master project...</option>
              {availableMasterProjects.map((masterProject) => (
                <option key={masterProject.id} value={masterProject.id}>
                  {masterProject.name} ({masterProject.project_count || 0} projects)
                </option>
              ))}
            </select>
          </div>

          <div className="modal-actions">
            <button
              type="button"
              onClick={handleCancel}
              className="cancel-button"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="submit-button"
              disabled={isSubmitting || !selectedMasterProjectId}
            >
              {isSubmitting ? 'Moving...' : 'Move Project'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default MoveProjectModal;